/*
 * Solorent – interruttore IVA (Turbo 11)
 * Ricalcola i prezzi mostrati nella scheda prodotto (prezzo, prezzo barrato, badge)
 * aggiungendo o togliendo l'IVA. Non tocca il codice del tema: osserva l'area prezzi
 * e, quando il tema la aggiorna dopo un cambio di variante, riapplica il calcolo.
 */
(function () {
  'use strict';
  if (window.__srVatLoaded) return;
  window.__srVatLoaded = true;

  var PRICE_SEL = '[data-price-ui] .money, [data-price-ui-badge] .money';

  function scopeOf(box) {
    return box.closest('.product__details') || box.closest('.js-product-section') || box.closest('.shopify-section') || document;
  }

  // "€304,00" · "€ 1.110,00" · "304,00 €" · "€304.00" -> centesimi
  function parseCents(txt) {
    var s = String(txt || '').replace(/[^\d.,]/g, '');
    if (!s) return null;
    var lc = s.lastIndexOf(','), ld = s.lastIndexOf('.');
    var decPos = Math.max(lc, ld);
    var intPart = s, frac = '';
    if (decPos > -1 && s.length - decPos - 1 <= 2) { intPart = s.slice(0, decPos); frac = s.slice(decPos + 1); }
    intPart = intPart.replace(/[.,]/g, '');
    if (!intPart && !frac) return null;
    return parseInt(intPart || '0', 10) * 100 + parseInt((frac + '00').slice(0, 2), 10);
  }

  function formatCents(cents) {
    var fmt = (document.body && document.body.getAttribute('data-money-format')) || '€{{amount_with_comma_separator}}';
    fmt = fmt.trim();
    function group(n, thousands, decimal, decimals) {
      var fixed = (n / 100).toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount_with_comma_separator';
    var val;
    switch (key) {
      case 'amount': val = group(cents, ',', '.', 2); break;
      case 'amount_no_decimals': val = group(cents, ',', '.', 0); break;
      case 'amount_with_apostrophe_separator': val = group(cents, "'", '.', 2); break;
      case 'amount_no_decimals_with_comma_separator': val = group(cents, '.', ',', 0); break;
      default: val = group(cents, '.', ',', 2);
    }
    return m ? fmt.replace(m[0], val) : val;
  }

  function apply(box) {
    var input = box.querySelector('[data-sr-vat-input]');
    if (!input) return;
    var on = input.checked;
    var incl = box.getAttribute('data-base-included') === 'true';
    var rate = parseFloat(box.getAttribute('data-rate')) || 0.22;
    var factor = on ? (incl ? 1 / (1 + rate) : 1 + rate) : 1;
    var status = box.querySelector('[data-sr-vat-status]');
    if (status) status.textContent = (on ? !incl : incl) ? 'IVA Inclusa' : 'IVA Esclusa';

    var els = scopeOf(box).querySelectorAll(PRICE_SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var current = el.textContent;
      // testo cambiato dal tema (nuova variante) o mai letto: è il nuovo prezzo di base
      if (el.getAttribute('data-sr-vat-orig') == null || current !== el.getAttribute('data-sr-vat-shown')) {
        var c = parseCents(current);
        if (c == null) continue;
        el.setAttribute('data-sr-vat-orig', current);
        el.setAttribute('data-sr-vat-base', String(c));
      }
      var next = factor === 1 ? el.getAttribute('data-sr-vat-orig') : formatCents(Math.round(parseInt(el.getAttribute('data-sr-vat-base'), 10) * factor));
      if (current !== next) el.textContent = next;
      el.setAttribute('data-sr-vat-shown', next);
    }
  }

  function watch(box) {
    if (box.__srVatWatched) return;
    box.__srVatWatched = true;
    var scope = scopeOf(box);
    var targets = scope.querySelectorAll('[data-price-ui], [data-price-ui-badge]');
    if (!window.MutationObserver) return;
    var pending = false;
    var obs = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      // dopo che il tema ha finito di aggiornare l'area prezzi
      setTimeout(function () { pending = false; apply(box); }, 0);
    });
    for (var i = 0; i < targets.length; i++) obs.observe(targets[i], { childList: true, subtree: true, characterData: true });
  }

  function init() {
    var boxes = document.querySelectorAll('[data-sr-vat-toggle]');
    for (var i = 0; i < boxes.length; i++) { watch(boxes[i]); apply(boxes[i]); }
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-sr-vat-input]')) return;
    var box = e.target.closest('[data-sr-vat-toggle]');
    if (box) apply(box);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  function hook() {
    if (hook.done || !window.InstantClick || typeof window.InstantClick.on !== 'function') return;
    hook.done = true;
    window.InstantClick.on('change', init);
  }
  document.addEventListener('DOMContentLoaded', hook);
  window.addEventListener('load', hook);
  window.SRVat = { parseCents: parseCents, formatCents: formatCents, refresh: init };
})();
